var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.284,
    height: 54.284,
    viewBox: "0 0 54.284 54.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(-725 -12169.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook",
    "data-name": "Icon awesome-facebook",
    d: "M54.846,27.87A27.142,27.142,0,1,0,23.463,54.846V35.763H16.569V27.87h6.895V21.853c0-6.843,4.049-10.623,10.252-10.623a41.526,41.526,0,0,1,6.076.533v6.717H36.368c-3.371,0-4.423,2.105-4.423,4.265V27.87h7.527l-1.2,7.894H31.945V54.846A27.267,27.267,0,0,0,54.846,27.87Z",
    transform: "translate(724.438 12169.153)",
    fill: "#fff     "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaWhite);
export default __webpack_public_path__ + "static/media/meta_white.e72f73333c6e9741a421777dcd2fce98.svg";
export { ForwardRef as ReactComponent };